<template>
  <div class="main-search d-inline-block">
    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text">
          <font-awesome-icon :icon="'search'"></font-awesome-icon>
        </div>
      </div>
      <input
              v-model="inputValue"
              @input="handleInput"
              :placeholder="$t('Search...')"
              type="text"
              class="form-control">
    </div>
  </div>
</template>

<script>

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    props: {
      initialSearch: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        inputValue: null,
        debounce: null,
        delay: 500
      }
    },
    methods: {
      handleInput($event) {
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
          this.$emit('input', $event.target.value)
        }, this.delay);
      }
    },
    mounted() {
      if (this.initialSearch) {
        this.inputValue = this.initialSearch;
      }
    }
  }
</script>

<style lang="scss">
  @import "./../../scss/index";

  .main-search {
    .input-group-text {
      background-color: $search-input-group-text-bg-color;
      color: $search-input-group-text-color;
    }

    input {
      width: $search-input-width !important;
      transition: $search-input-transition;

      &:focus {
        width: $search-input-focus-width !important;
      }
    }
  }
</style>
